export const GUEST_DOWNLOAD_URL_FRAGMENT = '/transition-document/guest/';

export enum GuestDownloadStep {
  Loading = 'loading',
  Landing = 'landing',
  CodeEntry = 'code-entry',
  Download = 'download',
  Unavailable = 'unavailable',
}

export enum GuestDownloadStatus {
  Available = 'available',
  NoLongerAvailable = 'no_longer_available',
  NotFound = 'not_found',
  Sent = 'sent',
  Cooldown = 'cooldown',
  Verified = 'verified',
  InvalidCode = 'invalid_code',
  CodeExpired = 'code_expired',
  Locked = 'locked',
  Ready = 'ready',
  Pending = 'pending',
  InvalidAccessToken = 'invalid_access_token',
}

export interface GuestDownloadStatusResponse {
  status: GuestDownloadStatus.Available | GuestDownloadStatus.NoLongerAvailable;
}

export interface RequestCodeResponse {
  status: GuestDownloadStatus.Sent;
  email_masked: string;
  retry_after_seconds: number;
  code_expires_in_seconds: number;
}

export interface VerifyCodeResponse {
  status: GuestDownloadStatus.Verified;
  access_token: string;
  access_token_expires_in_seconds: number;
}

export interface GuestDownloadResponse {
  status: GuestDownloadStatus.Ready | GuestDownloadStatus.Pending;
  url?: string;
}

export interface GuestDownloadErrorBody {
  status?: GuestDownloadStatus;
  attempts_left?: number;
  retry_after_seconds?: number;
}
